<template>
	<div class="pay-success">

			<div class=" pay-content">
				<div class="pay-img-div">
					<div class="pay-img" :class="pageDetail.payImgBgc">
						<img :src="pageDetail.payImgUrl" style="width: 40px;height: 40px;" />
					</div>
					<div class="pay-text-div">
						<div class="pay-text-title">{{ pageDetail.payTitle }}</div>
						<div class="pay-text-tips">{{ pageDetail.payTips }}</div>
					</div>
					
		
				</div>


			</div>


		<div v-show="isShowWenXinTips">
			<div>温馨提示：</div>
			<div class="wei-xin-content">
				{{ wenXinTips }}
			</div>
			<div class="wei-xin-item" v-for="(wenXinItem, index) in wenXinTipsList" :key="index">
				<a href="wenXinItem.url">{{ wenXinItem.name }}</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "PaySuccess",
	data() {
		return {
			isShowWenXinTips: false,
			wenXinTips: '由于网上银行和支付系统只支持IE浏览器，在您支付时，浏览器自动帮您切换到兼容模式<br/>当您看到此提示时，请您手动将浏览器切换到极速模式！',
			wenXinTipsList: [{
				name: "什么是极速模式",
				content: "",
				url: "https://zhidao.baidu.com/question/415571135.html",
			}, {
				name: "我该如何切换",
				content: "",
				url: "https://kf.qq.com/info/44692_0.html",
			}],
			tiaoTimer: null, // 跳转定时器
			times: 5,
			tiaoTimerForNoToken:null,
			timerForNoToken:5,

			orderDetail:{
				payStatus:0,
			},
			contentDetailMap:{
				0:{
					payImgUrl:require('@/assets/image/pay/time.png'),
					payImgBgc:"pay-zhong",
					payTitle:"支付中",
					payTips:"订单正在支付中，可以刷新订单查询状态",

				},
				1:{
					payImgUrl:require('@/assets/image/pay/dui.png'),
					payImgBgc:"pay-success",
					payTitle:"支付成功",
					payTips:"您的订单已支付完成",
	
				},
				2:{
					payImgUrl:require('@/assets/image/pay/tan.png'),
					payImgBgc:"pay-error",
					payTitle:"支付失败",
					payTips:"支付失败，请联系服务商处理",
				},
			},
		}
	},
	computed:{
		pageDetail(){
			return this.contentDetailMap[this.orderDetail.payStatus]

		}
	},
	mounted() {
	
		if(this.$route.query.uid){
			this.getOrderInfoForNoToken(this.$route.query.uid);
		}else{
			this.init();
		}
	},
	destroyed() {
		this.tiaoTimer = null;
	},
	methods: {
		init() {
			// 中核需要这样处理 他们支付完需要跳转到他们的页面 但是微信配置了链接他们支付会报错
			let returnUrl = this.$route.query.returnUrl;
			if (!!returnUrl) {
				// 后台支付成功给的是base64的字符串 需要解码
				returnUrl = atob(returnUrl || '');
				// returnUrl = returnUrl.split('').reverse().join(''); //其他地方跳转过来，returnUrl是逆序传入
						if (returnUrl.indexOf("http") != 0) { //说明没有带协议，默认为http
							returnUrl = "http://www.yjtravel.com/" + returnUrl;
						}
				window.location.href = returnUrl;
				return;
			}

			/**
				 * 在线支付支付，页面回跳到obt，极有可能造成sessionStorage中token无法获取
				 * 因此在选择支付后，检测token
				 * */
			var token = this.$common.sessionget("access_token") || "";
			if (token == "" || token == "null" || token == "undefined" || token.length != 32) {
				token = common.localget("tmpaccess") || '';
			}


			if (!token) {
				this.isShowWenXinTips = true;
				return false;
			}

			this.$common.sessionset("access_token", token);

			// 通过交易号获取详情
			var params = this.$common.parseQueryString();

			// this.getOrderDetail(out_trade_no);
			var out_trade_no = params["out_trade_no"];
			if (out_trade_no != "") {
				this.getOrderDetail(out_trade_no);
			}

		},
		// 无token支付，详情获取
		getOrderInfoForNoToken(uid) {
			var queryObj = {
				uid: uid
			};
			this.$conn.getConn('pay.avoidLoginPay')(queryObj, (res) => {
				var data = res.data || {};

				this.orderDetail = data;

				clearInterval(this.tiaoTimer)
				this.tiaoTimer = setInterval(function () {
					if (this.timerForNoToken <= 0) {
						clearInterval(this.tiaoTimer)
						
					} else {
						this.timerForNoToken--;
					
						this.getOrderInfoForNoToken(uid);
					}
				}, 1000);
			},(err)=>{

			})
		},
		
		// 通过交易号获取详情
		getOrderDetail(payInfoId) {
			if (payInfoId) {
				var param = {
					payInfoId: payInfoId
				};

				this.$conn.getConn("pay.getPayOrderIdList")(param, (resp) => {
					let orderList = resp.data;
					this.timer(orderList);
				}, (err) => {

				});
			} else {
				this.timer();
			}
		},
		timer(orderList) {
			var self = this;
			var timeDom = self.$refs['pay-success-time'], sec = 5;
			// 清除计时器setInterval
			clearInterval(self.tiaoTimer)
			self.tiaoTimer = setInterval(function () {
				if (sec == 0) {
					clearInterval(self.tiaoTimer)
					if (orderList) {
						self.goToOrderDetail(orderList);
					} else {
						// 清除计时器setInterval 暂不确定需要删除这个clearInterval
						clearInterval(self.tiaoTimer)
						// 仅在本页面显示即可
						// self.$router.replace({
						// 	path: "/yjTravel/myTravel/userCenter/order",
						// })
					}
				} else {
					sec--;
					timeDom.innerHTML = `${sec}秒`;

				}
			}, 1000);



		},
		// 跳转订单详情
		goToOrderDetail(orderList) {
			clearInterval(this.tiaoTimer)
			
			// 仅在本页面显示即可
			// if (orderList && orderList.length == 1) {

			// 	var order = orderList[0] || {};
			// 	var orderId = order["orderId"];//订单id
			// 	var orderType = order["orderType"];//订单类型
			// 	let path = this.$dict.detailConfig(orderType)
			// 	this.$router.replace({
			// 		path: path,
			// 		query: {
			// 			orderId: orderId,
			// 			orderType: orderType,
			// 		}
			// 	})

			// 	} else {
			// 	this.$router.replace({
			// 		// path:"/yjtravel/myTravel/order",
			// 		path: "/yjTravel/myTravel/userCenter/order"
			// 	})
			// }
		}



	}
}
</script>

<style class="scoped">
.pay-success{
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	padding-top: 50px;
}

.wei-xin-content {
	color: red;
	font-size: 12px;
}

.wei-xin-item {
	height: 40px;
	line-height: 40px;
	font-size: 12px;
}

.pay-content{
	width: 500px;
    margin: 0 auto;
    padding: 20px;
    background-color: #fff;
	border-radius: 8px;
  }
  .pay-img-div{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .pay-text-div{
    display: flex;
    flex-direction: column;
    align-items: center;
    .pay-text-title{
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      color: #222222;
      padding: 12px 0;
    }
    .pay-text-tips{
      font-size: 15px;
      font-weight: normal;
      line-height: 23px;
      text-align: center;

      color: rgba(34, 34, 34, 0.75);
      padding-bottom: 60px;
    }
  }

  .pay-img{
    width: 64px;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
  }
  .pay-img.pay-success{
    background: rgba(103, 235, 178,0.15);
  }
  .pay-img.pay-error{
    background: rgba(255, 151, 132,0.15);
  }
  .pay-img.pay-zhong{
    background: rgba(82, 183, 253,0.15);

  }
</style>
